import { Capacitor } from '@capacitor/core';
import
{
    CapacitorWifiConnect,
    ConnectState
} from '@falconeta/capacitor-wifi-connect';

import
{
    useEffect,
    useState
} from 'react';

type WLanSSIDResponse = Promise<{
    value: string;
    status: ConnectState;
}>;

export const getWLanSSID = async (): WLanSSIDResponse =>
{
    const platform = Capacitor.getPlatform();

    if (platform !== "web") {
        try {
            return await CapacitorWifiConnect.getDeviceSSID();
        } catch (e) {

        }
    }
    return await new Promise(resolve =>
        resolve({
            value: "",
            status: -3
        }));
};

export const useWLanSSID = (refresh: number = 0) =>
{
    const [SSID, setSSID] = useState<string | null>(null);

    useEffect(() =>
    {
        let timeout: NodeJS.Timeout;

        const updateSSID = () =>
        {
            getWLanSSID().then(({ value }) =>
            {
                setSSID((current) => (value !== current) ? value : current);
            }).catch((e) =>
            {
                console.log(e);
                setSSID(null);
            });

            if (refresh) {
                timeout = setTimeout(updateSSID, refresh);
            }
        };

        updateSSID();

        return () =>
        {
            clearTimeout(timeout);
        };

    }, [refresh]);

    return SSID;
};